import React from 'react';
import PropTypes from 'prop-types';
import {fromJS} from 'immutable';
import Tabs from 'sg/Tabs/Tabs.react';
import {history} from 'client/history';
import {query} from '@albert-io/json-api-framework/request/builder';
import StandardsTable from './StandardsTable/StandardsTable.react';
import StudentsTable from './StudentsTable/StudentsTable.react';
import './question-insights.scss';

const tabs = fromJS([
  {
    label: 'Students',
    query: {
      tab: null
    }
  },
  {
    label: 'Standards',
    query: {
      tab: 'standards'
    }
  }
]);

export default class QuestionInsights extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape({
        attempt: PropTypes.string,
        tab: PropTypes.string
      })
    }),
    params: PropTypes.shape({
      classId: PropTypes.string,
      questionId: PropTypes.string
    })
  };

  constructor(props) {
    super(props);
    if (!props.location.query.attempt) {
      history.pushState(null, `/classes/${props.params.classId}/insights`);
    }
  }

  getQuestionQuery = () => {
    return query().mandarkEndpoint(['questions_v2', this.props.params.questionId]);
  };

  render() {
    const question = this.getQuestionQuery().getResource();
    const questionTitle = this.getQuestionQuery().isResourcePopulated()
      ? <h1>{question.getTitle()}</h1>
      : null;

    return(
      <div className='question-insights'>
        {questionTitle}
        <Tabs
          className='question-insights__tabs'
          content={tabs}
        >
          {this.props.location.query.tab === 'standards'
            ? <StandardsTable />
            : <StudentsTable />
          }
        </Tabs>
      </div>
    );
  }
}
